import { forgotPassword } from '../../actions/passwordReset';
import RequestLinkForm from './RequestLinkForm';

export default function ForgotPassword() {
  return (
    <RequestLinkForm
      thunk={forgotPassword}
      side={{
        eyebrow: 'Account recovery',
        headline: "Locked out? We'll get you back in.",
        paragraph:
          'Enter the email you sign in with and we’ll send a single-use link to reset your password. The link works once and expires in an hour.',
      }}
      bracket="[ Security · Password reset ]"
      headline="Reset your password."
      lede="Tell us the email on your account and we’ll email a secure reset link. It expires in 1 hour for your protection."
      emailHint="Use the email you sign in with."
      ctaLabel="Send reset link →"
      confirmTitle="Check your inbox."
      confirmBody="If an account exists for that address, a reset link is on its way."
      confirmNote="The link expires in 1 hour. Don’t see it? Check your spam folder, then resend below."
    />
  );
}
